import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { ApiService } from 'src/app/services/api.service';
import { UtilService } from 'src/app/services/util.service';
import { AppSettings } from './../../services/AppSettings';

@Component({
  selector: 'app-follower',
  standalone: true,
  imports: [CommonModule, ReactiveFormsModule, FormsModule],
  templateUrl: './follower.component.html',
  styleUrls: ['./follower.component.scss']
})
export class FollowerComponent implements OnInit, OnChanges {

  @Input('title') title: any = 'Followers';
  @Input() inputData: string;
  headerTitle: string = 'Followers';
  commonDatahide:any={}
  // Support both @Output EventEmitter and @Input callback function for NgComponentOutlet
  @Output() commonFunction: any = new EventEmitter<string>();
  admin:any=[]
  @Input() maxMin: any = {};
  @Input() page: string;
   viewType: string = "MIN";
   imgUrl: any = AppSettings.photoUrl;

   @Input() widgetDesc: string;
   @Input() suggestion: any;
   constructor(private auth: ApiService,private a_route: ActivatedRoute,private router: Router, private util :UtilService) {
   }

  route(item) {
    this.router.navigate(['personalProfile'], { queryParams: item });
  }

  modelopen(data) {
    let dataPass: any = {};
    dataPass.data = data;
    dataPass.master = this.page;
    dataPass.menu = this.headerTitle || this.widgetDesc || 'Followers';
    dataPass.masterMenu =  this.inputData;
    dataPass.widgetName = "FollowerComponent";
    this.router.navigate(['suggestions'], { queryParams: dataPass })
  }

  ngOnChanges(changes: SimpleChanges): void {
    // Handle widgetDesc changes for NgComponentOutlet compatibility
    if (changes.widgetDesc && changes.widgetDesc.currentValue) {
      this.headerTitle = changes.widgetDesc.currentValue;
    }
  }

  ngOnInit() {
    // Only set headerTitle if widgetDesc is provided (ngOnChanges handles dynamic updates)
    if (this.widgetDesc) {
      this.headerTitle = this.widgetDesc;
    }

    this.a_route.queryParams.subscribe((res) => {
      if(res.master!="NETWORK" && res.master!="TEAM" && res.menu!=null &&res.menu!=undefined){
        this.headerTitle=res.menu;
      }
   })

    if (this.maxMin.viewType != undefined) {
      this.viewType = "MAX";
      this.inputData = this.maxMin.master;
     }

    if (this.inputData && this.inputData != null && this.inputData != "") {
      this.util.startLoader()

      if (this.inputData == "BUSINESS") {

        let datas: any = {};
        datas.businessId = localStorage.getItem('businessId')
        this.util.startLoader()
        this.auth.create('business/followers', datas).subscribe(res => {
          this.util.stopLoader()
           if ( res && res.data.businessFollowers.length!=0 && res != undefined && res != null) {
            if (res && res !=null  && res.length != 0){
              res.data.businessFollowers.forEach(element => {
                element.userName = element.firstName + " " + element.lastName;
                if (element.userId === localStorage.getItem('userId')) {
                  element.followedOn = new Date()
                }
                if (element.photo != null) {
                  element.image =""
                  element.image = AppSettings.photoUrl + element.photo;
                 } else {
                  element.image=""
                  element.image = "assets/images/userAvatar.png";
                }

              })
              this.admin=res.data.businessFollowers;
             }else{
              this.hide(true)
             }
          }  else{
              this.hide(true)
           }


          },err => {
            this.util.stopLoader();
          });




      } else if (this.inputData == "COMMUNITY") {


      } else if (this.inputData == "HOME") {

      }
    }


  }

  hide(flag){
    this.commonDatahide.widgetName="FollowerComponent";
    this.commonDatahide.hide = flag;
    // Support both EventEmitter (template binding) and callback function (NgComponentOutlet)
    if (typeof this.commonFunction === 'function') {
      this.commonFunction(this.commonDatahide);
    } else if (this.commonFunction?.emit) {
      this.commonFunction.emit(this.commonDatahide);
    }
  }

}


